import React from "react";
import styled from "styled-components";
import ProjectList from "../Resources/Projectlist";
import Carousel from 'react-multi-carousel';

const MC = styled.div`
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100vw;
    height: 100vh;
    background: rgba(139, 139, 139, 0.58);
    border: solid 5px red;
    z-index: 1001;

    color:white;

`
const Close = styled.div`
    position: absolute;
    top: ${props => props.$mobile ? "10px" : "50px"};
    right: ${props => props.$mobile ? "10px" : "50px"};
    width: 50px;
    height: 50px;
    cursor: pointer;
    font-size: 3rem;
    line-height: 2rem;
    font-weight: bold;

    -webkit-user-select: none; /* Safari */
    -ms-user-select: none; /* IE 10 and IE 11 */
     user-select: none; /* Standard syntax */
`
const ProjImg = styled.div`
    width: ${props => props.$mobile ? "90vw" : "50vw"};
    min-height: ${props => props.$mobile ? "45vh" : "50vh"};
    background-image: url("${props => props.$img}");
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
`
const CarouselBox = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: ${props => props.$mobile ? "90vw" : "90vw"};
    min-height: ${props => props.$mobile ? "90vw" : "30vh"};
    padding: 2vw;
    background: rgba(44, 44, 44, 0.7);
    border-radius: 25px;
    box-shadow: rgb(38, 57, 77) 0px 20px 30px -10px;
`
function closeClick(props) {
    props.setProj(null)
}

function Modal(props) {
    const responsive = {
        superLargeDesktop: {
            // the naming can be any, depends on you.
            breakpoint: { max: 4000, min: 3000 },
            items: 2
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 2
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 2
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1,
            partialVisibilityGutter: 40
        }
    };
    return (
        <MC >
            <CarouselBox $mobile={props.$mobile}>
                <Close $mobile={props.$mobile} onClick={() => closeClick(props)} >X</Close>
                <h1>{ProjectList[props.proj].name}</h1>
                <Carousel responsive={responsive} showDots={true} renderDotsOutside={true}>
                    <ProjImg $mobile={props.$mobile} $img={ProjectList[props.proj].images[0]} />
                    <ProjImg $mobile={props.$mobile} $img={ProjectList[props.proj].images[1]} />
                </Carousel>
            </CarouselBox>
        </MC>
    )
}
export default Modal